import { Navigate } from 'react-router-dom';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_SCOUTING_CENTER_STATS } from '@sorare/core/src/constants/__generated__/routes';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

const ScoutingCenterPage = () => {
  return (
    <Navigate
      to={generateSportPath(ANY_SPORT_SCOUTING_CENTER_STATS, {
        sport: Sport.NBA,
      })}
    />
  );
};

export default ScoutingCenterPage;
